import { Injectable } from '@angular/core';
import { Intercom } from 'ng-intercom';
import { AuthService } from '../core/auth.service';

@Injectable()
export class IntercomService {
  private readonly intercomAppId = 'jhd0ofyt';

  constructor(private intercom: Intercom, private auth: AuthService) {}

  shutDownIntercom() {
    try {
      this.intercom.shutdown();
    } catch (error) {
      console.error('Error shutting down Intercom');
      console.error(error);
    }
  }

  async initIntercomNonLoggedIn(meta_data) {
    try {
      const config = {
        app_id: this.intercomAppId,
        ...meta_data
      };
      this.intercom.boot(config);
    } catch (error) {
      console.error('Some error initializing intercom: ');
      console.error(error);
    }
  }

  async initIntercomLoggedIn(meta_data) {
    try {
      if (this.auth.isNormalUser() || this.auth.isClientAdmin()) {
        const customerName = await this.auth.getCustomerNameP();
        const customerEmail = this.auth.getEmailFromToken();
        const cognitoId = this.auth.getCognitoIdFromToken();

        // refer to https://www.npmjs.com/package/ng-intercom
        const config = {
          app_id: this.intercomAppId,
          name: customerName,
          email: customerEmail,
          user_id: cognitoId,
          ...meta_data
        };
        this.intercom.boot(config);
      }
    } catch (error) {
      console.error('Some error initializing intercom: ');
      console.error(error);
    }
  }
}



// WEBPACK FOOTER //
// /Users/sensorflow/Documents/legacy/kalinda/Dashboard/sensorflow-dashboard/src/app/shared/intercom.service.ts